import { getStore } from "../components/common/StoreCommon";

import { permissionAdded, getPermission } from "../store/hub/permissions";

export default class PermissionService {

  autoRefreshFeed() {
    return getPermission(getStore().getState())("AutoRefreshFeed");
  }

  setAutoRefreshFeed(value) {
    getStore().dispatch(permissionAdded( {AutoRefreshFeed: value} ));
  }

  canAddFeedTickerMessage() {
    return getPermission(getStore().getState())("CanAddFeedTickerMessage");
  }

  setCanAddFeedTickerMessage(value) {
    getStore().dispatch(permissionAdded( {CanAddFeedTickerMessage: value} ));
  }

  muteNotifications() {
    return getPermission(getStore().getState())("MuteNotifications");
  }

  setMuteNotifications(value) {
    getStore().dispatch(permissionAdded( {MuteNotifications: value} ));
  }
 
  playConversionSound() {
    return getPermission(getStore().getState())("PlayConversionSound");
  }

  setPlayConversionSound(value) {
    getStore().dispatch(permissionAdded( {PlayConversionSound: value} ));
  }

  bbPoolManagerFl() {
    return getPermission(getStore().getState())("BbPoolManagerFl");
  }

  setBbPoolManagerFl(value) {
    getStore().dispatch(permissionAdded( {BbPoolManagerFl: value} ));
  }

  bbDistributorFl() {
    return getPermission(getStore().getState())("BbDistributorFl");
  }

  setBbDistributorFl(value) {
    getStore().dispatch(permissionAdded( {BbDistributorFl: value} ));
  }

  enableBuzzBucks() {
    return getPermission(getStore().getState())("EnableBuzzBucks");
  }

  setEnableBuzzBucks(value) {
    getStore().dispatch(permissionAdded( {EnableBuzzBucks: value} ));
  }

  enableHrLeave() {
    return getPermission(getStore().getState())("EnableHrLeave");
  }

  setEnableHrLeave(value) {
    getStore().dispatch(permissionAdded( {EnableHrLeave: value} ));
  }

  hrAdminFl() {
    return getPermission(getStore().getState())("HrAdminFl");
  }

  setHrAdminFl(value) {
    getStore().dispatch(permissionAdded( {HrAdminFl: value} ));
  }
}
  